export default {
  namespaced: true,
  state: {
    chooseGroup: [],
    infoDetail: (sessionStorage.getItem('infoDetail') && JSON.parse(sessionStorage.getItem('infoDetail'))) || {}
  },
  mutations: {
    SET_INFO_DETAIL(state, detail) {
      sessionStorage.removeItem('infoDetail')
      if (detail) sessionStorage.setItem('infoDetail', JSON.stringify(detail))
      state.infoDetail = detail;
    },
    SET_CHOOSE_LIST(state, list) {
      state.chooseGroup = list;
    },
  },
  actions: {
    
  }
}